<template>
	<div>
		<v-card>
			<v-icon title="close" style="float: right" @click="close()">mdi-close</v-icon>
			<v-card-title>
				<span>Setup Wizard</span>
			</v-card-title>
			<v-card-text>
				<v-form v-model="valid" ref="formSetup" @submit.prevent="save()">
					<v-text-field v-model="experience.name" label="Experience Name" required></v-text-field>
					<v-text-field
						required
						v-model="experience.slug"
						:rules="[(v) => !!v || 'URL is required', (v) => /^[a-z0-9]*$/.test(v) || 'Must be alphanumeric with lowercase']"
						label="Experience URL"
					></v-text-field>
					<h2>Entrance</h2>
					<br />
					<img src="https://v-unite.com/events/wordpress/wp-content/uploads/2020/09/Exterior-3-1920x1080.jpg" width="70%" height="10%" />

					<v-col>
						<v-switch v-model="imageType1" :label="'Image type : ' + (imageType1 ? 'URL' : 'Upload')"></v-switch>
						<v-col cols="12" v-if="imageType1">
							<v-text-field
								v-model="setupWizard.structureList[7].linkToDataList[0].value"
								prepend-icon="mdi-image"
								label="Entrance Image(Left)"
								placeholder="From Url"
							></v-text-field>
						</v-col>
						<v-col cols="12" v-else>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-file-input
										v-on="on"
										v-bind="attrs"
										v-model="attachmentImage1"
										label="Entrance Image(Left)"
										accept="image/png, image/jpeg, image/jpg"
										placeholder="Upload Entrance Image(Left)"
										prepend-icon="mdi-image"
										:show-size="1000"
										:messages="'Current : ' + setupWizard.structureList[7].linkToDataList[0].value"
									>
										<template v-slot:selection="{ text }" :default="setupWizard.structureList[7].linkToDataList[0].value">
											<v-chip color="primary" dark label small>{{ text }}</v-chip>
										</template>
									</v-file-input>
								</template>
								<span>It’s recommended to use image with resolution approximately 270 x 440 pixels.</span>
							</v-tooltip>
						</v-col>
					</v-col>

					<v-col>
						<v-switch v-model="imageType2" :label="'Image type : ' + (imageType2 ? 'URL' : 'Upload')"></v-switch>
						<v-col cols="12" v-if="imageType2">
							<v-text-field
								v-model="setupWizard.structureList[7].linkToDataList[1].value"
								prepend-icon="mdi-image"
								label="Entrance Image(Right)"
								placeholder="From Url"
							></v-text-field>
						</v-col>
						<v-col cols="12" v-else>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-file-input
										v-on="on"
										v-bind="attrs"
										v-model="attachmentImage2"
										label="Entrance Image(Right)"
										accept="image/png, image/jpeg, image/jpg"
										placeholder="Upload Entrance Image(Right)"
										prepend-icon="mdi-image"
										:show-size="1000"
										:messages="'Current : ' + setupWizard.structureList[7].linkToDataList[1].value"
									>
										<template v-slot:selection="{ text }" :default="setupWizard.structureList[7].linkToDataList[1].value">
											<v-chip color="primary" dark label small>{{ text }}</v-chip>
										</template>
									</v-file-input>
								</template>
								<span>It’s recommended to use image with resolution approximately 270 x 440 pixels.</span>
							</v-tooltip>
						</v-col>
					</v-col>

					<h2>Lobby</h2>
					<br />
					<img src="https://v-unite.com/events/wordpress/wp-content/uploads/2020/09/Lobby-5-1920x1080.jpg" width="70%" height="10%" />
					<br />

					<v-col>
						<v-switch v-model="videoType" :label="'Video type : ' + (videoType ? 'URL' : 'Upload')"></v-switch>
						<v-col cols="12" v-if="videoType">
							<v-text-field
								v-model="setupWizard.structureList[6].linkToDataList[0].value"
								prepend-icon="mdi-image"
								label="Welcome Video"
								placeholder="From Url"
							></v-text-field>
						</v-col>
						<v-col cols="12" v-else>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-file-input
										v-on="on"
										v-bind="attrs"
										v-model="attachmentVideo"
										label="Welcome Video"
										accept="video/mp4"
										placeholder="Upload Welcome Video"
										prepend-icon="mdi-image"
										:show-size="1000"
										:messages="'Current : ' + setupWizard.structureList[6].linkToDataList[0].value"
									>
										<template v-slot:selection="{ text }" :default="setupWizard.structureList[6].linkToDataList[0].value">
											<v-chip color="primary" dark label small>{{ text }}</v-chip>
										</template>
									</v-file-input>
								</template>
								<span>It’s recommended to use video with resolution of 1080 pixels.</span>
							</v-tooltip>
						</v-col>
					</v-col>
					<p style="font-size: 18px; margin-top: 10px">Product Brochures :</p>
					<editor
						api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67"
						:init="initEditor"
						v-model="setupWizard.structureList[6].linkToDataList[1].value"
					/>
					<br />
					<p style="font-size: 18px; margin-top: 10px">Treatment Menu :</p>
					<editor
						api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67"
						:init="initEditor"
						v-model="setupWizard.structureList[6].linkToDataList[2].value"
					/>
					<br />

					<!--Product-->
					<v-card>
						<v-card-title class="headline">Product List</v-card-title>
						<v-card-text>
							<v-simple-table>
								<template v-slot:top>
									<v-toolbar flat color="white">
										<v-spacer></v-spacer>
										<v-btn color="primary" dark class="mb-2" @click="product.addDialog = true">Add New Product</v-btn>
									</v-toolbar>
								</template>
								<template v-slot:default>
									<thead>
										<tr>
											<th class="text-left" style="width: 24%">Name</th>
											<th class="text-left" style="width: 24%">Description</th>
											<th class="text-left" style="width: 24%">Image</th>
											<th class="text-left" style="width: 24%">URL Link</th>
											<th class="text-left">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(item, idxItem) in product.listProduct" :key="idxItem">
											<td class="longtext">{{ item.name }}</td>
											<td class="longtext">{{ item.description }}</td>
											<td class="longtext">{{ item.image }}</td>
											<td class="longtext">{{ item.urlLink }}</td>
											<td>
												<v-icon small class="mr-2" title="Edit" @click="chooseEditProduct(item.index)">mdi-pencil</v-icon>
												<v-icon small title="Delete" @click="deleteProduct(item)">mdi-delete</v-icon>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-card-text>
					</v-card>

					<v-dialog v-model="product.addDialog" persistent max-width="500px">
						<v-form
							ref="formAddProduct"
							v-model="product.validAddProduct"
							@submit.prevent="
								product.addDialog = false;
								addProduct();
							"
						>
							<v-card>
								<v-card-title>New Product</v-card-title>
								<v-card-text>
									<v-row class="d-flex">
										<v-col cols="12">
											<v-text-field v-model="product.newProduct.name" :rules="[(v) => !!v || 'Name is required']" label="Name" outlined dense></v-text-field>
										</v-col>
										<v-col cols="12">
											<v-textarea v-model="product.newProduct.description" :rules="[(v) => !!v || 'Description is required']" label="Description" outlined dense></v-textarea>
										</v-col>
										<v-col cols="3">
											<v-select v-model="product.imageType" :items="['URL', 'Upload']" label="Image Type"></v-select>
										</v-col>
										<v-col cols="9">
											<v-text-field v-if="product.imageType === 'URL'" v-model="product.newProduct.image" label="Image URL" outlined dense></v-text-field>
											<v-file-input
												v-else
												v-model="product.attachment"
												label="Image"
												accept="image/png, image/jpeg, image/jpg"
												hint="It’s recommended to use image approximately 125 x 125 pixels, under 500KB"
												placeholder="Upload Image"
												prepend-icon="mdi-image"
												:show-size="1000"
											>
												<template v-slot:selection="{ text }" :default="product.newProduct.image">
													<v-chip color="primary" dark label small>{{ text }}</v-chip>
												</template>
											</v-file-input>
										</v-col>
										<v-col cols="12">
											<v-text-field v-model="product.newProduct.urlLink" label="URL Link" outlined dense></v-text-field>
										</v-col>
									</v-row>
								</v-card-text>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn color="mr-2" text @click="closeAddProduct()">Cancel</v-btn>
									<v-btn color="primary" type="submit" text :disabled="!product.validAddProduct">Save</v-btn>
								</v-card-actions>
							</v-card>
						</v-form>
					</v-dialog>

					<v-dialog v-model="product.editDialog" persistent max-width="500px">
						<v-form
							ref="formEditProduct"
							v-model="product.validEditProduct"
							@submit.prevent="
								product.editDialog = false;
								editProduct(product.newProduct.index);
							"
						>
							<v-card>
								<v-card-title>Edit Product</v-card-title>
								<v-card-text>
									<v-row class="d-flex">
										<v-col cols="12">
											<v-text-field v-model="product.newProduct.name" :rules="[(v) => !!v || 'Name is required']" label="Name" outlined dense></v-text-field>
										</v-col>
										<v-col cols="12">
											<v-textarea v-model="product.newProduct.description" :rules="[(v) => !!v || 'Description is required']" label="Description" outlined dense></v-textarea>
										</v-col>

										<v-col cols="3">
											<v-select v-model="product.imageType" :items="['URL', 'Upload']" label="Image Type"></v-select>
										</v-col>
										<v-col cols="9">
											<v-text-field v-if="product.imageType === 'URL'" v-model="product.newProduct.image" label="Image URL" outlined dense></v-text-field>
											<v-file-input
												v-else
												v-model="product.attachment"
												label="Image"
												accept="image/png, image/jpeg, image/jpg"
												hint="It’s recommended to use image approximately 125 x 125 pixels, under 500KB"
												placeholder="Upload Image"
												prepend-icon="mdi-image"
												:show-size="1000"
											>
												<template v-slot:selection="{ text }" :default="product.newProduct.image">
													<v-chip color="primary" dark label small>{{ text }}</v-chip>
												</template>
											</v-file-input>
										</v-col>
										<v-col cols="12">
											<v-text-field v-model="product.newProduct.urlLink" label="URL Link" outlined dense></v-text-field>
										</v-col>
									</v-row>
								</v-card-text>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn color="mr-2" text @click="closeEditProduct()">Cancel</v-btn>
									<v-btn color="primary" type="submit" :disabled="!product.validEditProduct" text>Save</v-btn>
								</v-card-actions>
							</v-card>
						</v-form>
					</v-dialog>

					<br />
					<!--Presentation-->
					<h2>Education Room</h2>
					<br />
					<img src="https://v-unite.com/events/wordpress/wp-content/uploads/2020/09/Education-Room-1920x1080.jpg" width="70%" height="10%" />
					<br />
					<v-card style="margin-top: 30px">
						<v-card-title class="headline">Presentation List</v-card-title>
						<v-card-text>
							<v-simple-table>
								<template v-slot:top>
									<v-toolbar flat color="white">
										<v-spacer></v-spacer>
										<v-btn color="primary" dark class="mb-2" @click="showAddPresentation()">Add Presentation</v-btn>
									</v-toolbar>
								</template>
								<template v-slot:default>
									<thead>
										<tr>
											<th class="text-left" style="width: 24%">Title</th>
											<th class="text-left" style="width: 24%">Description</th>
											<th class="text-left" style="width: 24%">Type</th>
											<th class="text-left">Actions</th>
										</tr>
									</thead>
									<tbody v-if="entityPresentationList.length > 0">
										<tr v-for="(item, idxItem) in entityPresentationList" :key="idxItem">
											<td class="longtext">{{ item.title }}</td>
											<td class="longtext">{{ item.description }}</td>
											<td class="longtext">{{ item.type }}</td>
											<td>
												<v-icon small class="mr-2" title="Edit" @click="selectEditPresentation(item)">mdi-pencil</v-icon>
												<v-icon small title="Delete" @click="selectDeletePresentationSchedule(item)">mdi-delete</v-icon>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-card-text>
					</v-card>

					<v-dialog v-model="dialogPresentation" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
						<v-card v-if="entityPresentationList.length > 0 && (dialogPresentation || dialogEditPresentation)">
							<v-card-title class="headline">
								Add Presentation
								<v-spacer></v-spacer>
								<v-btn icon @click="closePresentation()">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								<v-row>
									<v-col cols="12" class="my-n4">
										Presentation
										<v-text-field v-model="entityPresentationList[currentIndex].title" label="Title" dense outlined></v-text-field>
										<v-text-field v-model="entityPresentationList[currentIndex].description" label="Description" dense outlined></v-text-field>
										<v-select
											v-model="entityPresentationList[currentIndex].type"
											:items="['On-Demand Video', 'Pre-recorded Video', 'Zoom Webinar', 'Zoom Meeting']"
											label="Type"
											dense
											outlined
										></v-select>
										<v-text-field
											v-if="
												entityPresentationList[currentIndex].type &&
												(entityPresentationList[currentIndex].type == 'On-Demand Video' ||
													entityPresentationList[currentIndex].type == 'Pre-recorded Video')
											"
											v-model="entityPresentationList[currentIndex].videoUrl"
											label="Video URL"
											dense
											outlined
										></v-text-field>
										<v-text-field
											v-if="
												entityPresentationList[currentIndex].type &&
												(entityPresentationList[currentIndex].type == 'Zoom Webinar' ||
													entityPresentationList[currentIndex].type == 'Zoom Meeting')
											"
											v-model="entityPresentationList[currentIndex].zoomUrl"
											label="Zoom URL"
											dense
											outlined
										></v-text-field>Schedule
										<v-menu
											ref="startDate"
											v-model="isShowStartDate"
											:close-on-content-click="false"
											:return-value.sync="
												entityPresentationScheduleList[currentIndex].dataMap.dateStart
											"
											transition="scale-transition"
											offset-y
											max-width="290px"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													label="Start Date"
													:rules="[
														(v) =>
															!!v ||
															'Start Date is required',
													]"
													prepend-icon="mdi-calendar-clock"
													v-bind="attrs"
													v-on="on"
													dense
													autocomplete="off"
													:value="formatDateTime(entityPresentationScheduleList[currentIndex].dataMap.dateStart)"
													@click="resetTime"
												></v-text-field>
											</template>
											<v-date-picker
												v-model="entityPresentationScheduleList[currentIndex].dataMap.dateStart"
												@input="
													entityPresentationScheduleList[currentIndex].dataMap.dateStart = changeDatetime(
														entityPresentationScheduleList[currentIndex].dataMap.dateStart
													)
												"
												color="primary"
												no-title
											>
												<div
													class="d-flex flex-column"
													style="width: 100%"
												>
													<div
														class="d-flex flex-row align-space-arround"
													>
														<span>Time</span>
														<v-select
															v-model="hour"
															:items="
																Array(24)
																	.fill()
																	.map((x, i) =>
																		(
																			'' + i
																		).padStart(
																			2,
																			'0'
																		)
																	)
															"
															class="mx-2"
															style="width: 10px"
															dense
															append-icon="false"
															@input="
																entityPresentationScheduleList[currentIndex].dataMap.dateStart = changeDatetime(
																	entityPresentationScheduleList[currentIndex].dataMap.dateStart
																)
															"
														>
															<template
																v-slot:selection="{
																	item,
																}"
															>
																<span
																	class="d-flex justify-center pl-6"
																	style="width: 100%"
																	>{{ item }}</span
																>
															</template> </v-select
														>:
														<v-select
															v-model="minute"
															:items="
																Array(60)
																	.fill()
																	.map((x, i) =>
																		(
																			'' + i
																		).padStart(
																			2,
																			'0'
																		)
																	)
															"
															class="mx-2"
															style="width: 10px"
															dense
															append-icon="false"
															@input="
																entityPresentationScheduleList[currentIndex].dataMap.dateStart = changeDatetime(
																	entityPresentationScheduleList[currentIndex].dataMap.dateStart
																)
															"
														>
															<template
																v-slot:selection="{
																	item,
																}"
															>
																<span
																	class="d-flex justify-center pl-6"
																	style="width: 100%"
																	>{{ item }}</span
																>
															</template> </v-select
														>
													</div>
													<v-divider></v-divider>
													<div class="d-flex justify-end">
														<v-btn
															text
															color="primary"
															@click="
																$refs.startDate.save(
																	(entityPresentationScheduleList[currentIndex].dataMap.dateStart = changeDatetime(
																		entityPresentationScheduleList[currentIndex].dataMap.dateStart
																	))
																)
															"
															>OK</v-btn
														>
													</div>
												</div>
											</v-date-picker>
										</v-menu>
										
										<v-menu
											ref="endDate"
											v-model="isShowEndDate"
											:close-on-content-click="false"
											:return-value.sync="
												entityPresentationScheduleList[currentIndex].dataMap.dateEnd
											"
											transition="scale-transition"
											offset-y
											max-width="290px"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													label="End Date"
													:rules="[
														(v) =>
															!!v ||
															'End Date is required',
													]"
													prepend-icon="mdi-calendar-clock"
													v-bind="attrs"
													v-on="on"
													dense
													autocomplete="off"
													:value="formatDateTime(entityPresentationScheduleList[currentIndex].dataMap.dateEnd)"
													@click="resetTime"
												></v-text-field>
											</template>
											<v-date-picker
												v-model="entityPresentationScheduleList[currentIndex].dataMap.dateEnd"
												@input="
													entityPresentationScheduleList[currentIndex].dataMap.dateEnd = changeDatetime(
														entityPresentationScheduleList[currentIndex].dataMap.dateEnd
													)
												"
												color="primary"
												no-title
											>
												<div
													class="d-flex flex-column"
													style="width: 100%"
												>
													<div
														class="d-flex flex-row align-space-arround"
													>
														<span>Time</span>
														<v-select
															v-model="hour"
															:items="
																Array(24)
																	.fill()
																	.map((x, i) =>
																		(
																			'' + i
																		).padStart(
																			2,
																			'0'
																		)
																	)
															"
															class="mx-2"
															style="width: 10px"
															dense
															append-icon="false"
															@input="
																entityPresentationScheduleList[currentIndex].dataMap.dateEnd = changeDatetime(
																	entityPresentationScheduleList[currentIndex].dataMap.dateEnd
																)
															"
														>
															<template
																v-slot:selection="{
																	item,
																}"
															>
																<span
																	class="d-flex justify-center pl-6"
																	style="width: 100%"
																	>{{ item }}</span
																>
															</template> </v-select
														>:
														<v-select
															v-model="minute"
															:items="
																Array(60)
																	.fill()
																	.map((x, i) =>
																		(
																			'' + i
																		).padStart(
																			2,
																			'0'
																		)
																	)
															"
															class="mx-2"
															style="width: 10px"
															dense
															append-icon="false"
															@input="
																entityPresentationScheduleList[currentIndex].dataMap.dateEnd = changeDatetime(
																	entityPresentationScheduleList[currentIndex].dataMap.dateEnd
																)
															"
														>
															<template
																v-slot:selection="{
																	item,
																}"
															>
																<span
																	class="d-flex justify-center pl-6"
																	style="width: 100%"
																	>{{ item }}</span
																>
															</template> </v-select
														>
													</div>
													<v-divider></v-divider>
													<div class="d-flex justify-end">
														<v-btn
															text
															color="primary"
															@click="
																isShowEndDate = false
															"
															>Cancel</v-btn
														>
														<v-btn
															text
															color="primary"
															@click="
																$refs.endDate.save(
																	(entityPresentationScheduleList[currentIndex].dataMap.dateEnd = changeDatetime(
																		entityPresentationScheduleList[currentIndex].dataMap.dateEnd
																	))
																)
															"
															>OK</v-btn
														>
													</div>
												</div>
											</v-date-picker>
										</v-menu>
										<v-autocomplete
											v-model="entityPresentationScheduleList[currentIndex].timezone"
											:items="timezoneList"
											hide-selected
											label="Timezone"
											required
										></v-autocomplete>
										<div>
											<br />Selected Presenter:
											<br />
											<span v-for="(person, idxPerson) in entityPresentationList[currentIndex].presenterClinicList" :key="idxPerson">
												{{ person.firstName != null ? person.firstName : "" }}
												{{ person.lastName != null ? person.lastName : "" }}
												{{ person.title != null ? person.title : ""}}
												<v-btn icon v-if="person.firstName" @click.prevent="removePresenterClinic(person)">
													<span>&#10005;</span>
												</v-btn>
												<br />
											</span>
											<br />
										</div>Presenter 1
										<v-file-input
											v-model="attachment1"
											label="Presenter Picture"
											accept="image/png, image/jpeg"
											placeholder="Upload Presenter Picture"
											prepend-icon="mdi-image"
											:show-size="1000"
										></v-file-input>
										<v-text-field v-model="firstName1" label="First Name" dense outlined></v-text-field>
										<v-text-field v-model="lastName1" label="Last Name" dense outlined></v-text-field>
										<v-text-field v-model="title1" label="Title" dense outlined></v-text-field>
										<v-textarea v-model="bio1" label="Biography" dense outlined></v-textarea>Presenter 2
										<v-file-input
											v-model="attachment2"
											label="Presenter Image"
											accept="image/png, image/jpeg"
											placeholder="Upload Presenter Image"
											prepend-icon="mdi-image"
											:show-size="1000"
										></v-file-input>
										<v-text-field v-model="firstName2" label="First Name" dense outlined></v-text-field>
										<v-text-field v-model="lastName2" label="Last Name" dense outlined></v-text-field>
										<v-text-field v-model="title2" label="Title" dense outlined></v-text-field>
										<v-textarea v-model="bio2" label="Biography" dense outlined></v-textarea>Presenter 3
										<v-file-input
											v-model="attachment3"
											label="Presenter Image"
											accept="image/png, image/jpeg"
											placeholder="Upload Presenter Image"
											prepend-icon="mdi-image"
											:show-size="1000"
										></v-file-input>
										<v-text-field v-model="firstName3" label="First Name" dense outlined></v-text-field>
										<v-text-field v-model="lastName3" label="Last Name" dense outlined></v-text-field>
										<v-text-field v-model="title3" label="Title" dense outlined></v-text-field>
										<v-textarea v-model="bio3" label="Biography" dense outlined></v-textarea>
										<div>
											Uploaded Handout:
											<br />
											<span v-for="(handout, idxHandout) in entityPresentationList[currentIndex].handoutList" :key="idxHandout">
												{{ handout.title }}
												<v-btn icon @click.prevent="removeHandout(handout)" v-if="handout.title">
													<span>&#10005;</span>
												</v-btn>
												<br />
											</span>
										</div>Handout 1
										<v-file-input v-model="attachment4" label="Handout 1" accept="application/pdf" placeholder="Upload Handout 1" prepend-icon="mdi-image" :show-size="1000"></v-file-input>
										<br />Handout 2
										<v-file-input v-model="attachment5" label="Handout 2" accept="application/pdf" placeholder="Upload Handout 2" prepend-icon="mdi-image" :show-size="1000"></v-file-input>
										<br />Handout 3
										<v-file-input v-model="attachment6" label="Handout 3" accept="application/pdf" placeholder="Upload Handout 3" prepend-icon="mdi-image" :show-size="1000"></v-file-input>
									</v-col>
									<v-col cols="12" class="text-right">
										<v-btn
											v-if="dialogEditPresentation == false"
											color="primary"
											@click="
												addPresentation();
												closePresentation();
											"
										>Add</v-btn>
										<v-btn
											v-if="dialogEditPresentation == true"
											color="primary"
											@click="
												addPresentation();
												closePresentation();
											"
										>Save</v-btn>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-dialog>
					<!-- Delete Presentation Schedule -->
					<v-dialog v-model="dialogDeletePresentationSchedule" max-width="600px">
						<v-card>
							<v-card-title>
								<span class="headline">Delete Presentation Schedule</span>
							</v-card-title>
							<v-card-text>Are you sure to delete this presentation schedule ?</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="blue darken-1" text @click.prevent="dialogDeletePresentationSchedule = false">Cancel</v-btn>
								<v-btn
									color="blue darken-1"
									text
									@click.prevent="
										dialogDeletePresentationSchedule = false;
										deletePresentationSchedule(currentIndex);
									"
								>Delete</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>

					<div class="d-flex justify-end" style="margin-top: 60px">
						<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Submit</v-btn>
					</div>
				</v-form>
			</v-card-text>
		</v-card>
	</div>
</template>

<style scoped>
</style>

<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";

export default {
	props: ["experienceId"],
	components: {
		editor: Editor
	},
	data() {
		return {
			currentIndex: null,
			valid: true,
			imageType1: true,
			imageType2: true,
			videoType: true,
			product: {
				validForm: false,
				dialog: false,
				addDialog: false,
				validAddProduct: true,
				editDialog: false,
				validEditProduct: true,
				listProduct: [],
				newProduct: {},
				attachment: null,
				imageType: "URL"
			},
			experience: {
				status: false,
				dataMap: { twitterId: null, ongoing: true},
				transitMap: {},
				menuDataList: [{"id":"wl2gakt9a","name":"Room Navigation","childList":[{"id":"ftx40q3rr","name":"Lobby","linkType":"Room","linkTo":"lobby"},{"id":"a7ootxjmj","name":"Room Selection","linkType":"Room","linkTo":"roomselection"},{"id":"qkf8qgmsv","name":"Education Room","linkType":"Room","linkTo":"educationroom"},{"id":"tbzc6qifk","name":"Consultation Room 1","linkType":"Room","linkTo":"consultationroom1"},{"id":"e70c5w0xl","name":"Consultation Room 2","linkType":"Room","linkTo":"consultationroom2"},{"id":"sn3dog1sn","name":"Treatment Room 1","linkType":"Room","linkTo":"treatmentroom1"},{"id":"pka17uwwm","name":"Treatment Room 2"}]}]
			},
			setupWizard: {
				presentationList: [],
				presentationScheduleList: [],
				structureList: [
					//Education Room(0)
					{
						background: "https://v-unite.com/events/wordpress/wp-content/uploads/2020/09/Education-Room-1920x1080.jpg",
						mainStructure: false,
						dataMap: {},
						name: "Education Room",
						slug: "educationroom",
						linkToDataList: [
							{
								id: 1,
								type: "Presentation",
								width: "44",
								height: "42",
								posX: "14",
								posY: "6",
								value: ""
							}
						]
					},
					//Consultation Room 1(1)
					{
						background: "https://v-unite.com/events/wordpress/wp-content/uploads/2020/09/Consultation-1920x1080.jpg",
						mainStructure: false,
						dataMap: {},
						linkToDataList: [
							{
								id: 1,
								type: "Book_Consultation",
								width: "36",
								height: "8",
								posX: "32",
								posY: "17",
								value: ""
							}
						],
						name: "Consultation Room 1",
						slug: "consultationroom1"
					},
					//Consultation Room 2(2)
					{
						background: "https://v-unite.com/events/wordpress/wp-content/uploads/2020/09/Consultation-1920x1080.jpg",
						mainStructure: false,
						dataMap: {},
						linkToDataList: [
							{
								id: 1,
								type: "Attend_Consultation",
								width: "36",
								height: "8",
								posX: "32",
								posY: "17",
								value: ""
							}
						],
						name: "Consultation Room 2",
						slug: "consultationroom2"
					},
					//Treatment Room 1(3)
					{
						background: "https://v-unite.com/events/wordpress/wp-content/uploads/2020/09/Treatment-Room-1-1-1920x1080.jpg",
						mainStructure: false,
						dataMap: {},
						linkToDataList: [
							{
								id: 1,
								type: "Presentation",
								width: "9",
								height: "8",
								posX: "39",
								posY: "19",
								value: ""
							},
							{
								id: 2,
								type: "Book_Consultation",
								width: "9",
								height: "8",
								posX: "48",
								posY: "19",
								value: ""
							},
							{
								id: 3,
								type: "Dialog",
								width: "9",
								height: "8",
								posX: "58",
								posY: "19",
								value: ""
							}
						],
						name: "Treatment Room 1",
						slug: "treatmentroom1"
					},
					//Treatment Room 2(4)
					{
						background: "https://v-unite.com/events/wordpress/wp-content/uploads/2020/09/Treatment-Room-2-1-1920x1080.jpg",
						mainStructure: false,
						dataMap: {},
						linkToDataList: [
							{
								id: 1,
								type: "Presentation",
								width: "9",
								height: "8",
								posX: "39",
								posY: "19",
								value: ""
							},
							{
								id: 2,
								type: "Book_Consultation",
								width: "9",
								height: "8",
								posX: "48",
								posY: "19",
								value: ""
							},
							{
								id: 3,
								type: "Dialog",
								width: "9",
								height: "8",
								posX: "58",
								posY: "19",
								value: ""
							}
						],
						name: "Treatment Room 2",
						slug: "treatmentroom2"
					},
					//Room Selection
					{
						background: "https://v-unite.com/events/wordpress/wp-content/uploads/2020/09/Corridor-1-1920x1080.jpg",
						mainStructure: false,
						dataMap: {},
						linkToDataList: [
							//Treatment Room 1
							{
								id: 1,
								type: "Structure",
								width: "16",
								height: "9",
								posX: "33",
								posY: "7",
								value: ""
							},
							//Treatment Room 2
							{
								id: 2,
								type: "Structure",
								width: "10",
								height: "6",
								posX: "40",
								posY: "26",
								value: ""
							},
							//Consultation Room 1
							{
								id: 3,
								type: "Structure",
								width: "16",
								height: "9",
								posX: "50",
								posY: "7",
								value: ""
							},
							//Education Room
							{
								id: 4,
								type: "Structure",
								width: "10",
								height: "6",
								posX: "51",
								posY: "26",
								value: ""
							}
						],
						name: "rooms",
						slug: "roomselection"
					},
					//Lobby
					{
						background: "https://v-unite.com/events/wordpress/wp-content/uploads/2020/09/Lobby-5-1920x1080.jpg",
						mainStructure: false,
						dataMap: {},
						name: "Lobby",
						slug: "lobby",
						linkToDataList: [
							//welcome video
							{
								id: 1,
								type: "Video",
								width: "10",
								height: "10",
								posX: "41",
								posY: "28",
								value: null
							},
							//product brochure
							{
								id: 2,
								type: "Dialog",
								width: "15",
								height: "6",
								posX: "16",
								posY: "42",
								value: ""
							},
							//treatment menu
							{
								id: 3,
								type: "Dialog",
								width: "18",
								height: "8",
								posX: "27",
								posY: "79",
								value: ""
							},
							//product
							{
								id: 4,
								type: "Product",
								width: "10",
								height: "7",
								posX: "56",
								posY: "29",
								value: ""
							},
							//book consultation
							{
								id: 5,
								type: "Structure",
								width: "16",
								height: "8",
								posX: "82",
								posY: "64",
								value: ""
							},
							{
								id: 6,
								type: "Structure",
								width: "10",
								height: "7",
								posX: "70",
								posY: "32",
								value: ""
							}
						]
					},
					//Entrance
					{
						background: "https://v-unite.com/events/wordpress/wp-content/uploads/2020/09/Exterior-3-1920x1080.jpg",
						mainStructure: true,
						dataMap: {},
						name: "Entrance",
						slug: "entrance",
						linkToDataList: [
							{
								id: 1,
								type: "Image",
								width: "21",
								height: "61",
								posX: "7",
								posY: "18",
								value: ""
							},
							{
								id: 2,
								type: "Image",
								width: "21",
								height: "61",
								posX: "73",
								posY: "18",
								value: ""
							},
							//enter
							{
								id: 3,
								type: "Structure",
								width: "13",
								height: "8",
								posX: "44",
								posY: "53",
								value: ""
							}
						]
					}
				]
			},
			attachment1: null,
			attachment2: null,
			attachment3: null,
			attachmentImage1: null,
			attachmentImage2: null,
			attachmentVideo: null,
			initEditor: {
				height: 600,
				image_title: true,
				automatic_uploads: true,
				file_picker_types: "file image media",
				images_upload_credentials: false,
				image_dimensions: true,
				menubar: true,
				images_upload_handler: (blobInfo, success,failure) => {
					let formdata = new FormData()
					formdata.append("attachment1",blobInfo.blob())
					formdata.append("tenantId", this.$store.state.principal.tenantId)
					axios.post("/system/structure/tinymce/image/upload", formdata)
					.then((res) => {
						if (res.data != null) {
							success(axios.defaults.baseURL + '/asset/file/' + res.data)
						} else {
							failure('upload failed!')
						}	
					})
				},
				media_live_embeds: true,
				plugins: ["code", "media", "image", "preview", "link"],
				toolbar:
					"code undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help |media |image |file |preview |link"
			},
			//Presentation
			entityPresentationList: [],
			entityPresentationScheduleList: [],
			timezoneList: [],
			selectedTimezone: null,
			videoUrl: null,
			zoomUrl: null,
			isShowStartDate: false,
			isShowEndDate: false,
			isShowStartTime: false,
			isShowEndTime: false,
			selectedType: null,
			selectedTitle: null,
			selectedDescription: null,
			dialogPresentation: false,
			attachment4: null,
			attachment5: null,
			attachment6: null,
			firstName1: null,
			lastName1: null,
			bio1: null,
			title1: null,
			image1: null,
			firstName2: null,
			lastName2: null,
			bio2: null,
			title2: null,
			image2: null,
			firstName3: null,
			lastName3: null,
			bio3: null,
			title3: null,
			image3: null,
			handoutTitle1: null,
			handoutValue1: null,
			handoutTitle2: null,
			handoutValue2: null,
			handoutTitle3: null,
			handoutValue3: null,
			presenterIndex1: null,
			presenterIndex2: null,
			presenterIndex3: null,
			dialogEditPresentation: false,
			selectedPresentationId: null,
			selectedPresentationScheduleId: null,
			dialogDeletePresentationSchedule: false,
			presentationLimit : 0,
			startDate: null,
			endDate: null,
			startTime: null,
			endTime: null,
			hour: null,
			minute: null,
			today:
				new Date().getFullYear() +
				"-" +
				(new Date().getMonth() + 1) +
				"-" +
				new Date().getDate(),
		};
	},
	mounted() {
		this.listTimezone();
		this.getPresentationLimit();
	},
	methods: {
		getPresentationLimit(){
			axios.get("/system/clinic/presentation/limit").then((response) => {
				this.presentationLimit = response.data;
			})
		},
		save() {
			let formData = new FormData();
			if (this.attachmentImage1) {
				formData.append("attachmentImage1", this.attachmentImage1);
			}
			if (this.attachmentImage2) {
				formData.append("attachmentImage2", this.attachmentImage2);
			}
			if (this.attachmentVideo) {
				formData.append("attachmentVideo", this.attachmentVideo);
			}
			formData.append("experience", JSON.stringify(this.experience));
			this.setupWizard.structureList[3].linkToDataList[2].value = this.setupWizard.structureList[6].linkToDataList[1].value;
			this.setupWizard.structureList[4].linkToDataList[2].value = this.setupWizard.structureList[6].linkToDataList[1].value;
			this.setupWizard.presentationList = this.entityPresentationList;
			this.setupWizard.presentationScheduleList = this.entityPresentationScheduleList;
			console.log(JSON.stringify(this.setupWizard.presentationList));
			formData.append("setupWizard", JSON.stringify(this.setupWizard));
			axios
				.post("/system/clinic/setup", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					this.$refs.formSetup.reset();
					this.$router.push("/tenant/experience");
				});
		},
		close() {
			this.$refs.formSetup.reset();
			this.$router.push("/tenant/experience");
		},
		//Product
		async addProduct() {
			this.product.newProduct.index = 0;
			if (this.product.listProduct != null) {
				this.product.newProduct.index = this.product.listProduct.length;
			}

			let formData = new FormData();
			if (this.product.imageType === "Upload" && this.product.attachment) {
				if (this.product.attachment) {
					formData.append("productAttachment", this.product.attachment);
				}
				let structureId = 0;
				let experienceId = 0;
				formData.append("experienceId", JSON.stringify(experienceId));
				formData.append("structureId", JSON.stringify(structureId));
				await axios.post("/system/structure/linkto/product/image", formData).then(response => {
					this.product.newProduct.image = response.data;
				});
			}

			this.product.listProduct.push(this.product.newProduct);
			this.product.attachment = null;
			this.product.newProduct = {};
			this.resetForms();
			this.setupWizard.structureList[6].linkToDataList[3].value = JSON.stringify(this.product.listProduct);
		},
		chooseEditProduct(index) {
			this.product.editDialog = true;
			this.product.newProduct = Object.assign({}, this.product.listProduct[index]);
		},
		async editProduct(index) {
			let formData = new FormData();
			if (this.product.imageType === "Upload" && this.product.attachment) {
				if (this.product.attachment) {
					formData.append("productAttachment", this.product.attachment);
				}
				let structureId = 0;
				let experienceId = 0;
				formData.append("experienceId", JSON.stringify(experienceId));
				formData.append("structureId", JSON.stringify(structureId));
				await axios.post("/system/structure/linkto/product/image", formData).then(response => {
					this.product.newProduct.image = response.data;
				});
			}

			this.product.listProduct.splice(index, 1, this.product.newProduct);
			this.product.attachment = null;
			this.product.newProduct = {};
			this.setupWizard.structureList[6].linkToDataList[3].value = JSON.stringify(this.product.listProduct);
			this.resetForms();
		},
		deleteProduct(item) {
			if (confirm("Are you sure to remove " + item.name + "?")) {
				this.product.listProduct.splice(item.index, 1);
				if (this.product.listProduct != null) {
					let i = 0;
					this.product.listProduct.forEach(item => {
						item.index = i;
						i++;
					});
				}
				this.setupWizard.structureList[6].linkToDataList[3].value = JSON.stringify(this.product.listProduct);
			}
		},
		resetForms() {
			if (this.$refs.formAddProduct) {
				this.$refs.formAddProduct.reset();
			}
			if (this.$refs.formEditProduct) {
				this.$refs.formEditProduct.reset();
			}
		},
		closeAddProduct() {
			this.product.addDialog = false;
			this.product.newProduct = {};
			this.resetForms();
		},
		closeEditProduct() {
			this.product.editDialog = false;
			this.product.newProduct = {};
			this.resetForms();
		},

		//Presentation

		uploadFile() {
			let isUpload = false;
			let formData = new FormData();
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
				isUpload = true;
			}
			if (this.attachment2) {
				formData.append("attachment2", this.attachment2);
				isUpload = true;
			}
			if (this.attachment3) {
				formData.append("attachment3", this.attachment3);
				isUpload = true;
			}
			if (this.attachment4) {
				formData.append("attachment4", this.attachment4);
				isUpload = true;
			}
			if (this.attachment5) {
				formData.append("attachment5", this.attachment5);
				isUpload = true;
			}
			if (this.attachment6) {
				formData.append("attachment6", this.attachment6);
				isUpload = true;
			}
			if (this.firstName1 || this.lastName1 || this.bio1) {
				let presenterClinic = {
					firstName: this.firstName1,
					lastName: this.lastName1,
					title: this.title1,
					bio: this.bio1,
					image: this.image1
				};
				this.entityPresentationList[this.currentIndex].presenterClinicList.push(presenterClinic);
				this.presenterIndex1 = this.entityPresentationList[this.currentIndex].presenterClinicList.indexOf(presenterClinic);
			}
			if (this.firstName2 || this.lastName2 || this.bio2) {
				let presenterClinic = {
					firstName: this.firstName2,
					lastName: this.lastName2,
					title: this.title2,
					bio: this.bio2,
					image: this.image2
				};
				this.entityPresentationList[this.currentIndex].presenterClinicList.push(presenterClinic);
				this.presenterIndex2 = this.entityPresentationList[this.currentIndex].presenterClinicList.indexOf(presenterClinic);
			}
			if (this.firstName3 || this.lastName3 || this.bio3) {
				let presenterClinic = {
					firstName: this.firstName3,
					lastName: this.lastName3,
					title: this.title3,
					bio: this.bio3,
					image: this.image3
				};
				this.entityPresentationList[this.currentIndex].presenterClinicList.push(presenterClinic);
				this.presenterIndex3 = this.entityPresentationList[this.currentIndex].presenterClinicList.indexOf(presenterClinic);
			}
			if (isUpload) {
				axios.post("/system/clinic/presentation/upload", formData).then(response => {
					let fileList = [];
					fileList = response.data;
					if (fileList[0] != null && this.presenterIndex1 != null) {
						this.image1 = fileList[0];
						this.entityPresentationList[this.currentIndex].presenterClinicList[this.presenterIndex1].image = this.image1;
					}
					if (fileList[1] != null && this.presenterIndex2 != null) {
						this.image2 = fileList[1];
						this.entityPresentationList[this.currentIndex].presenterClinicList[this.presenterIndex2].image = this.image2;
					}
					if (fileList[2] != null && this.presenterIndex3 != null) {
						this.image3 = fileList[2];
						this.entityPresentationList[this.currentIndex].presenterClinicList[this.presenterIndex3].image = this.image3;
					}
					if (fileList[3] != null) {
						this.handoutValue1 = fileList[3];
						this.handoutTitle1 = fileList[4];
						let handout = {
							title: this.handoutTitle1,
							value: this.handoutValue1
						};
						this.entityPresentationList[this.currentIndex].handoutList.push(handout);
					}
					if (fileList[5] != null) {
						this.handoutValue2 = fileList[5];
						this.handoutTitle2 = fileList[6];
						let handout = {
							title: this.handoutTitle2,
							value: this.handoutValue2
						};
						this.entityPresentationList[this.currentIndex].handoutList.push(handout);
					}
					if (fileList[7] != null) {
						this.handoutValue3 = fileList[7];
						this.handoutTitle3 = fileList[8];
						let handout = {
							title: this.handoutTitle3,
							value: this.handoutValue3
						};
						this.entityPresentationList[this.currentIndex].handoutList.push(handout);
					}
				});
			}
		},
		formatDate(date) {
			if (date != null) {
				var year = parseInt(date.substring(0, 4));
				var month = parseInt(date.substring(5, 7));
				var day = parseInt(date.substring(8, 10));
				const monthNames = [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December"
				];
				return day + " " + monthNames[month - 1] + " " + year;
			} else {
				return "";
			}
		},
		listTimezone() {
			axios
				.get("/system/enumeration/timezone/list")
				.then(response => {
					this.timezoneList = response.data;
				})
				.catch(() => {});
		},
		clearPresentation() {
			this.isShowStartDate = false;
			this.isShowEndDate = false;
			this.isShowStartTime = false;
			this.isShowEndTime = false;
			this.attachment1 = null;
			this.attachment2 = null;
			this.attachment3 = null;
			this.attachment4 = null;
			this.attachment5 = null;
			this.attachment6 = null;
			(this.firstName1 = null),
				(this.lastName1 = null),
				(this.bio1 = null),
				(this.title1 = null),
				(this.image1 = null),
				(this.firstName2 = null),
				(this.lastName2 = null),
				(this.bio2 = null),
				(this.title2 = null),
				(this.image2 = null),
				(this.firstName3 = null),
				(this.lastName3 = null),
				(this.bio3 = null),
				(this.title3 = null),
				(this.image3 = null),
				(this.handoutTitle1 = null),
				(this.handoutValue1 = null),
				(this.handoutTitle2 = null),
				(this.handoutValue2 = null),
				(this.handoutTitle3 = null),
				(this.handoutValue3 = null);
		},
		closePresentation() {
			if (!this.dialogEditPresentation && this.entityPresentationList[this.currentIndex].title == null) {
				this.entityPresentationList.splice(this.currentIndex, 1);
			}
			this.dialogPresentation = false;
			this.dialogEditPresentation = false;
			this.clearPresentation();
		},
		showAddPresentation() {
			let index = 0;
			let presentationSize = 1;
			if (this.entityPresentationList != null) {
				index = this.entityPresentationList.length;
				presentationSize = index + 1;
			}
			
			if(presentationSize > this.presentationLimit){
				alert("Unable to add because you have reached the plan's limit. Please upgrade your plan to increase the limit.")
			} else {
				this.dialogPresentation = true;
				this.currentIndex = index;
				this.presenterIndex1 = null;
				this.presenterIndex2 = null;
				this.presenterIndex3 = null;
				this.entityPresentationList.push({
					title: null,
					description: null,
					type: null,
					videoUrl: null,
					participantUrl: null,
					status: false,
					handoutList: [],
					presenterClinicList: [],
					dataMap: {}
				});
				this.entityPresentationScheduleList.push({
					timezone: null,
					dataMap: {}
				});
			}
		},
		addPresentation() {
			this.uploadFile();
			const zeroPad = (num, places) => String(num).padStart(places, '0')
			var hour = zeroPad(parseInt(this.entityPresentationScheduleList[this.currentIndex].dataMap.dateStart.substring(11, 13)) , 2);
			var minute = zeroPad(parseInt(this.entityPresentationScheduleList[this.currentIndex].dataMap.dateStart.substring(14, 16)), 2);
			this.startTime = hour + ":" + minute;
			if (this.entityPresentationScheduleList[this.currentIndex].dataMap.dateStart) {
				if (this.startTime) {
					this.entityPresentationScheduleList[this.currentIndex].dataMap.startDate = this.entityPresentationScheduleList[this.currentIndex].dataMap.dateStart;
					this.entityPresentationScheduleList[this.currentIndex].dataMap.startTime = this.startTime;
				} else {
					this.entityPresentationScheduleList[this.currentIndex].dataMap.startDate = this.entityPresentationScheduleList[this.currentIndex].dataMap.dateStart + " " + "00:00";
				}
			}
			if (this.startTime) {
				this.entityPresentationScheduleList[this.currentIndex].dataMap.startTime = this.startTime;
			}

			hour = zeroPad(parseInt(this.entityPresentationScheduleList[this.currentIndex].dataMap.dateEnd.substring(11, 13)) , 2);
			minute = zeroPad(parseInt(this.entityPresentationScheduleList[this.currentIndex].dataMap.dateEnd.substring(14, 16)), 2);
			this.endTime = hour + ":" + minute;
			if (this.entityPresentationScheduleList[this.currentIndex].dataMap.dateEnd) {
				if (this.endTime) {
					this.entityPresentationScheduleList[this.currentIndex].dataMap.endDate = this.entityPresentationScheduleList[this.currentIndex].dataMap.dateEnd;
					this.entityPresentationScheduleList[this.currentIndex].dataMap.endTime = this.endTime;
				} else {
					this.entityPresentationScheduleList[this.currentIndex].dataMap.endDate = this.entityPresentationScheduleList[this.currentIndex].dataMap.dateEnd + " " + "00:00";
				}
			}
			if (this.endTime) {
				this.entityPresentationScheduleList[this.currentIndex].dataMap.endTime = this.endTime;
			}
		},
		resetTime() {
			this.hour = "00";
			this.minute = "00";
			this.second = "00";
		},
		formatDateTime(date) {
			if (date != null) {
				const zeroPad = (num, places) => String(num).padStart(places, '0')
				var year = parseInt(date.substring(0, 4));
				var month = parseInt(date.substring(5, 7));
				var day = parseInt(date.substring(8, 10));
				var hour = zeroPad(parseInt(date.substring(11, 13)) , 2);
				var minute = zeroPad(parseInt(date.substring(14, 16)), 2);
				const monthNames = [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December"
				];
				return day + " " + monthNames[month - 1] + " " + year + " " + hour + ":" + minute;
			} else {
				return "";
			}
		},
		changeDatetime: function (dateTime) {
			if (dateTime === "") {
				return (
					this.today +
					" " +
					this.hour +
					":" +
					this.minute
				);
			} else {
				return (
					dateTime.substr(0, 10) +
					" " +
					this.hour +
					":" +
					this.minute
				);
			}
		},
		deletePresentationSchedule(currentIndex) {
			this.entityPresentationList.splice(currentIndex, 1);
			this.entityPresentationScheduleList.splice(currentIndex, 1);
		},
		selectEditPresentation(item) {
			this.dialogPresentation = true;
			this.dialogEditPresentation = true;
			this.currentIndex = this.entityPresentationList.indexOf(item);
		},
		selectDeletePresentationSchedule(item) {
			this.dialogDeletePresentationSchedule = true;
			this.currentIndex = this.entityPresentationList.indexOf(item);
		},
		removePresenterClinic(item) {
			this.entityPresentationList[this.currentIndex].presenterClinicList = this.entityPresentationList[
				this.currentIndex
			].presenterClinicList.filter(x => x != item);
		},
		removeHandout(handout) {
			this.entityPresentationList[this.currentIndex].handoutList = this.entityPresentationList[this.currentIndex].handoutList.filter(
				x => x != handout
			);
		}
	}
};
</script>